export default "__VITE_ASSET__BF80x94P__$_?url__"